import React from "react";
import jsonArraySort from "../../../services/jsonArraySort";

import SortableHeader from "../../../components/SortableHeader";

function useSeachResults(results) {
  const [query, setQuery] = React.useState("");
  const [filteredResults, setFilteredResults] = React.useState(results);

  React.useMemo(() => {
    const result = results.filter((_viewer) => {
      return `${_viewer.name} ${_viewer.email} $`
        .toLowerCase()
        .includes(query.toLocaleLowerCase());
    });
    setFilteredResults(result);
  }, [results, query]);

  return { query, setQuery, filteredResults };
}

const fields = [
  {
    text: "Nombre",
    parameter: "name",
  },
  {
    text: "Correo",
    parameter: "email",
  },
  {
    sortable: true,
    text: "Hora Ingreso",
    parameter: "time_in",
  },
  {
    sortable: true,
    text: "Hora Salida",
    parameter: "time_out",
  },
  {
    sortable: false,
    text: "Duración",
    parameter: "duration",
  },
];

function Table(props) {
  const { query, setQuery, filteredResults } = useSeachResults(props.rows),
    [sortParameter, setSortParameter] = React.useState({
      parameter: "name",
      order: "asc",
    });

  if (sortParameter.order === "DESC") {
    filteredResults.sort(jsonArraySort(sortParameter.parameter).DESC);
  } else {
    filteredResults.sort(jsonArraySort(sortParameter.parameter).ASC);
  }

  return (
    <div className="az-content az-content-events">
      <div className="az-content-body">
        <div className="mg-t-20 mg-b-30">
          <div className="az-header-events-center">
            <input
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
              }}
              type="search"
              className="form-control"
              placeholder={"Filtrar"}
              disabled={props.rows.length === 0}
            />
            <button className="btn">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
        <div className="table-responsive subscribers-table">
          <table className="table table-hover mg-b-0">
            <thead>
              <SortableHeader
                sortParameter={sortParameter}
                setSortParameter={setSortParameter}
                fields={fields}
              />
            </thead>
            <tbody>
              {filteredResults.map((row, index) => {
                console.log(row.name, row.time_in);
                return (
                  <tr key={index}>
                    <td className="name-cell">{row.name}</td>
                    <td>{row.email}</td>
                    <td>{row.date_in}</td>
                    <td>{row.date_out}</td>
                    <td>{row.duration}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Table;
